import { TypeKind } from './types.js';
import { typeSymbol } from './engine-impl.js';
import { OclEngine, OclExecutionContext, OclParser } from '@canvas-logic/ocl';
import { DeepModelWalker } from './internal/ModelWalker.js';
import { Utils } from "@canvas-logic/ocl";
class ExpressionConstraint {
    constructor(errorMessage) {
        this.errorMessage = errorMessage;
        this.expression = () => true;
    }
    evaluate(model, option) {
        return this.expression(model, option);
    }
}
export class JsExpressionConstraint extends ExpressionConstraint {
    constructor(expression, errorMessage) {
        super(errorMessage);
        this.expression = expression;
    }
}
export class OclExpressionConstraint extends ExpressionConstraint {
    constructor(oclExpression, errorMessage, schema) {
        super(errorMessage);
        this.schema = schema;
        let packageDeclaration;
        this.oclExpression = oclExpression;
        try {
            packageDeclaration = OclEngine.Parser.parse(oclExpression, [], OclParser.registeredTypes);
        }
        catch (e) {
            e.oclExpression = oclExpression;
            throw e;
        }
        this.expression = (model) => {
            Utils.typeDeterminerFn = function () {
                return model[typeSymbol];
            };
            const visitor = new OclExecutionContext(model);
            visitor.registerStatics(this.schema.staticAPI);
            visitor.registerTypes(OclParser.registeredTypes);
            packageDeclaration.evaluate(visitor);
            if (visitor.getFailedInvariants().length > 0) {
                return false;
            }
            const walker = new DeepModelWalker(this.schema, model, model[typeSymbol]);
            let propValue;
            while (propValue = walker.next()) {
                let type = this.schema.getType(propValue.property.type);
                if (type.kind == TypeKind.Object) {
                    Utils.typeDeterminerFn = function () {
                        return propValue.property.type;
                    };
                    const visitor = new OclExecutionContext(propValue.value);
                    visitor.registerStatics(this.schema.staticAPI);
                    visitor.registerTypes(OclParser.registeredTypes);
                    packageDeclaration.evaluate(visitor);
                    if (visitor.getFailedInvariants().length > 0) {
                        return false;
                    }
                }
            }
            return true;
        };
    }
}
export function createExpressionConstraint(constraint, schema) {
    if (constraint.jsExpression) {
        return new JsExpressionConstraint(eval(`(function () {
      return ${constraint.jsExpression};
    })()`), constraint.errorMessage);
    }
    else if (constraint.oclExpression && schema) {
        return new OclExpressionConstraint(constraint.oclExpression, constraint.errorMessage, schema);
    }
}
var Constraints;
(function (Constraints) {
    Constraints["MinLength"] = "MinLength";
    Constraints["MaxLength"] = "MaxLength";
    Constraints["Required"] = "Required";
    Constraints["Pattern"] = "Pattern";
    Constraints["NumberRange"] = "NumberRange";
    Constraints["UniqueItems"] = "UniqueItems";
})(Constraints || (Constraints = {}));
class BaseConstraint {
    constructor(name) {
        this.name = name;
    }
}
class MinLengthConstraint extends BaseConstraint {
    constructor() {
        super(Constraints.MinLength);
        this.min = 0;
    }
    valid(value) {
        return value.length < this.min;
    }
}
class RequiredConstraint extends BaseConstraint {
    constructor() {
        super(Constraints.Required);
    }
    valid(value) {
        return value != null;
    }
}
class UniqueConstraint extends BaseConstraint {
    constructor() {
        super(Constraints.UniqueItems);
    }
    valid(value) {
        throw new Error('Not implemented yet!');
    }
}
class ConstraintInstance {
    constructor(name, kwargs = {}) {
        this.name = name;
        this.kwargs = kwargs;
    }
}
export { MinLengthConstraint, RequiredConstraint, UniqueConstraint, Constraints, ConstraintInstance, ExpressionConstraint };
//# sourceMappingURL=constraint.js.map